import mapDownloadDataToTemplate from './mapDownloadDataToTemplate';
import mapProductDataToTemplate from './mapProductDataToTemplate';
import mapReferenceDataToTemplate from './mapReferenceDataToTemplate';
import mapTopicDataToTemplate from './mapTopicDataToTemplate';

const mappingsByType = {
    product: mapProductDataToTemplate,
    reference: mapReferenceDataToTemplate,
    topic: mapTopicDataToTemplate,
    download: mapDownloadDataToTemplate,
};

/**
 * Maps results of a given type to their corresponding templates.
 * @param {string} type
 * @param {Object[]} results
 * @param {Object} typeTemplate
 * @returns {Element[]}
 */
const mapResultsToTemplate = (type, results, typeTemplate) => {
    const $itemTemplate = $(typeTemplate)
        .find('[data-template]')
        .clone()
        .removeAttr('[data-template]');

    const mapDataToTemplate = mappingsByType[type];
    return mapDataToTemplate
        ? mapDataToTemplate(results, $itemTemplate)
        : [];
};

export default mapResultsToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/search/mapResultsToTemplate.js